import { useEffect } from 'react';
import { Container, Row, Col, Badge, Button } from 'react-bootstrap';
import './FormationsCard.css';

import BClogo from '../assets/img/logos/bussiness_central.avif';
import TeconLogo from '../assets/img/logos/teconLogo.avif';
import MicrosoftLogo from '../assets/img/logos/microsoftLogo.avif'
import youtubeLogo from '../assets/img/logos/youtubeLogo.avif'
import gitLogo from '../assets/img/logos/gitLogo.avif'
import aiLogo from '../assets/img/logos/aiLogo.avif'
import awsLogo from '../assets/img/logos/awsLogo.avif'
import awsAcademyLogo from '../assets/img/logos/awsAcademyLogo.avif'
import cibersecurity from '../assets/img/logos/cibersecurity.avif'
import bigschool from '../assets/img/logos/big_school_logo.avif'

import { FaRegCalendar, FaRegClock } from 'react-icons/fa';
import { FaXmark } from 'react-icons/fa6';

const FormationsCard = ({ onClose }) => {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };

        window.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'unset';
        };
    }, [onClose]);

    const Formaciones = [
        {
            id: 5,
            tipo: 'imagen',
            icono: cibersecurity,
            titulo: "Jornadas de ciberseguridad y hacking ético",
            plataforma: "BIG School",
            plataformaLogo: bigschool,
            fecha: "2026",
            duracion: "6 horas",
            temas: [
                "Hacking Web",
                "Detección de vulnerabilidades",
                "IA aplicada a ciberseguridad",
                "Recuperación de datos"
            ],
            certificado: "https://www.linkedin.com/feed/update/urn:li:activity:7448669630430146560/"
        }, {
            id: 0,
            tipo: 'imagen',
            icono: aiLogo,
            titulo: "Curso Inteligencia Artificial para Programadores 2026",
            plataforma: "YouTube | Midudev",
            plataformaLogo: youtubeLogo,
            fecha: "2026",
            duracion: "2 horas",
            temas: [
                "Trabajo basado en Tokens",
                "Editores de código con IA",
                "Agentes de IA",
                "Claude Code",
                "MCPs",
                "Opencode",
                "NotebookLM"
            ]
        }, {
            id: 1,
            tipo: 'imagen',
            icono: BClogo,
            titulo: "Microsoft Business Central AL Development",
            plataforma: "Grupo TECON",
            plataformaLogo: TeconLogo,
            fecha: "2026",
            duracion: "30 horas",
            temas: [
                "Desarrollo en AL",
                "Manejos de tipos Blob y Media",
                "Extensiones y customizaciones",
                "Diseño de tablas y páginas",
                "Creación de informes",
                "Desarrollo de Apps",
            ],
            certificado: "/certis/certificado_AL_tecon.pdf"
        },
        {
            id: 2,
            tipo: 'imagen',
            icono: BClogo,
            titulo: "Introducción al desarrollo en Business Central",
            plataforma: "Microsoft Learn",
            plataformaLogo: MicrosoftLogo,
            fecha: "2026",
            duracion: "8 horas",
            temas: [
                "Fundamentos de AL",
                "Uso de campos calculados",
                "Lógica de negocio (Codeunits)",
                "Creación de Tablas y Extensiones",
                "Visualización de elementos"
            ],
            certificado: "https://learn.microsoft.com/es-es/users/juanngelpearrubia-6129/achievements/kc8vejpb?ref=https%3A%2F%2Fwww.linkedin.com%2F"
        },
        {
            id: 3,
            tipo: 'imagen',
            icono: awsLogo,
            titulo: "AWS Cloud Security",
            plataforma: "AWS Training",
            plataformaLogo: awsAcademyLogo,
            fecha: "2026",
            duracion: "20 horas",
            temas: [
                "Arquitectura en la nube",
                "Servicios principales de AWS",
                "Seguridad y cumplimiento",
                "Monitorización de Eventos",
                "EC2, S3, RDS, Lambda"
            ],
            certificado: "https://www.credly.com/badges/750cc4da-15c3-45ea-97d5-bd2770f6fb1c/linked_in_profile"
        },
        {   /*TODO AÑADIR LOGOS, ICONOS Y TAL*/
            id: 4,
            tipo: 'imagen',
            icono: gitLogo,
            titulo: "Curso completo de GIT y GITHUB",
            plataforma: "YouTube | MoureDev",
            plataformaLogo: youtubeLogo,
            fecha: "2025",
            duracion: "5 horas",
            temas: [
                "Instalación",
                "Repositorios locales y remotos",
                "Comandos desde Consola",
                "Creación y cambio entre ramas",
                "Mergeo y resolución de conflictos"
            ],
            certificado: null
        }];

    return (
        <div className="formacion-overlay" onClick={onClose}>
            <div className="formacion-container" onClick={(e) => e.stopPropagation()}>
                <button className="formacion-close" onClick={onClose}>
                    <strong><FaXmark style={{ fontSize: '1.5rem', marginTop: '-4px' }} /></strong>
                </button>

                <div className="formacion-header">
                    <Container fluid>
                        <Row className="align-items-center">
                            <Col>
                                <h2>📜 Formación Complementaria</h2>
                                <p>Cursos y certificaciones que complementan mi formación académica</p>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="formacion-content">
                    <Row className="g-4">
                        {Formaciones.map((curso) => (
                            <Col xs={12} key={curso.id}>
                                <div className="curso-item">
                                    {/* Header del curso con Grid */}
                                    <Row className="mb-3">
                                        {/* Nueva columna para icono a la izquierda */}
                                        <Col md={1} xs={4} className="d-flex align-items-center p-1">
                                            {curso.tipo === 'imagen' ? (
                                                <img
                                                    src={curso.icono}
                                                    alt={curso.titulo}
                                                    className="curso-logo"
                                                    style={{ width: '100%', height: '100%', objectFit: 'contain', maxHeight: '80px' }}
                                                />
                                            ) : (
                                                <span className="curso-icono-principal">
                                                    {curso.icono}
                                                </span>
                                            )}
                                        </Col>

                                        <Col md={9} xs={8}>
                                            <div className="mb-2 mt-1">
                                                <h3 className="curso-titulo mb-0 text-start">{curso.titulo}</h3>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <Badge bg="transparent" className="ps-1">
                                                    {curso.plataformaLogo ? (
                                                        <img
                                                            src={curso.plataformaLogo}
                                                            alt={`Logo ${curso.plataforma}`}
                                                            className="plataforma-logo"
                                                        />
                                                    ) : (
                                                        <span className="plataforma-icon-generico">🏢</span>
                                                    )}{curso.plataforma}
                                                </Badge>
                                            </div>
                                        </Col>

                                        <Col md={2} xs={12} className="text-md-end mt-0 mt-md-0 d-flex flex-row flex-md-column align-items-center align-items-md-end gap-2">
                                            <Badge bg="transparent" className="meta-badge">
                                                <FaRegCalendar className="me-1" /> {curso.fecha}
                                            </Badge>
                                            <Badge bg="transparent" className="meta-badge">
                                                <FaRegClock className="me-1" /> {curso.duracion}
                                            </Badge>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <div className="curso-temas">
                                                <div className="d-flex flex-wrap gap-2 pt-5">
                                                    {curso.temas.map((tema, index) => (
                                                        <div className="tema-item" key={index}>
                                                            <span className="tema-check">✓</span>
                                                            {tema}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {curso.certificado && (
                                        <Row className="mt-5">
                                            <Col xs={12}>
                                                <Button
                                                    variant="primary"
                                                    href={curso.certificado}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn-certificado"
                                                >
                                                    📄 Ver Certificado
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default FormationsCard;